export const DeleteSavedWidgets = ({
    setIsDeviceMenu,
    currentDevice,
    tempTabIndexDevices,
    activeTabIndex,
    selectedDevice,
    setTempTabIndexDevices,
    setUpdatedTabIndexDevices,
    setTabIndexDevices,
    indicatorRefs,
    tempImages,
    setTempImages,
    setUpdatedImages,
    setIndexesToDeleteImg,
    indexesToDeleteImg,
    tempTabIndexDisplay,
    setTempTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    setTabIndexDisplay,
    displayRefs,
    tempTabIndexController,
    setTempTabIndexController,
    setUpdatedTabIndexController,
    setTabIndexController,
    controllerRefs,
    tempTabIndexIO,
    setTempTabIndexIO,
    setUpdatedTabIndexIO,
    setTabIndexIO,
    ioRefs,
    tempTabIndexFlowM,
    setTempTabIndexFlowM,
    setUpdatedTabIndexFlowM,
    setTabIndexFlowM,
    flowMRefs,
    setTabIndexEnergyM,
    tempTabIndexEnergyM,
    setTempTabIndexEnergyM,
    setUpdatedTabIndexEnergyM,
    energyMRefs,
    tempTabIndexMotor,
    setTempTabIndexMotor,
    setUpdatedTabIndexMotor,
    setTabIndexMotor,
    motorRefs,
    tempTabIndexText,
    setTempTabIndexText,
    setUpdatedTabIndexText,
    setTabIndexText,
    textRefs,
    tempTabIndexLineChart,
    setTempTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    setTabIndexLineChart,
    lineChartRefs,
    tempTabIndexPieChart,
    setTempTabIndexPieChart,
    setUpdatedTabIndexPieChart,
    setTabIndexPieChart,
    pieChartRefs,
    tempTabIndexBarChart,
    setTempTabIndexBarChart,
    setUpdatedTabIndexBarChart,
    setTabIndexBarChart,
    barChartRefs,
    tempTabIndexHistogram,
    setTempTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    setTabIndexHistogram,
    histogramRefs,
    tempTabIndexGauge,
    setTempTabIndexGauge,
    setUpdatedTabIndexGauge,
    setTabIndexGauge,
    gaugeRefs,
    tempTabIndexProgress,
    setTempTabIndexProgress,
    setUpdatedTabIndexProgress,
    setTabIndexProgress,
    progressBarRefs,
    tempTabIndexGrid,
    setTempTabIndexGrid,
    setUpdatedTabIndexGrid,
    setTabIndexGrid,
    gridRefs,
    tempTabIndexTable,
    setTempTabIndexTable,
    setUpdatedTabIndexTable,
    setTabIndexTable,
    tableRefs,
    tempTabIndexCircularProgress,
    setTempTabIndexCircularProgress,
    setUpdatedTabIndexCircularProgress,
    setTabIndexCircularProgress,
    circularProgressRefs,
    tempTabIndexDoughnut,
    setTempTabIndexDoughnut,
    setUpdatedTabIndexDoughnut,
    setTabIndexDoughnut,
    doughnutRefs,
    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,
    setTabIndexLines,
    lineRefs,
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    setTabIndexSquare,
    squareRefs,
    circleRefs,
    setTabIndexCircle,
    setUpdatedTabIndexCircle,
    setTempTabIndexCircle,
    tempTabIndexCircle,
    polygoneRefs,
    setTabIndexPolygone,
    setUpdatedTabIndexPolygone,
    setTempTabIndexPolygone,
    tempTabIndexPolygone,
    pipeRefs,
    setTabIndexPipe,
    setUpdatedTabIndexPipe,
    setTempTabIndexPipe,
    tempTabIndexPipe,
    switchRefs,
    setTabIndexSwitch,
    setUpdatedTabIndexSwitch,
    setTempTabIndexSwitch,
    tempTabIndexSwitch,
    checkboxRefs,
    setTabIndexCheckbox,
    setUpdatedTabIndexCheckbox,
    setTempTabIndexCheckbox,
    tempTabIndexCheckbox,
    radioRefs,
    setTabIndexRadio,
    setUpdatedTabIndexRadio,
    setTempTabIndexRadio,
    tempTabIndexRadio,
    sliderRefs,
    setTabIndexSlider,
    setUpdatedTabIndexSlider,
    setTempTabIndexSlider,
    tempTabIndexSlider,
    lampRefs,
    setTabIndexLamp,
    setUpdatedTabIndexLamp,
    setTempTabIndexLamp,
    tempTabIndexLamp,
    pushRefs,
    setTabIndexPush,
    setUpdatedTabIndexPush,
    setTempTabIndexPush,
    tempTabIndexPush,
    LinkRefs,
    setTabIndexLink,
    setUpdatedTabIndexLink,
    setTempTabIndexLink,
    tempTabIndexLink,
    clockrefs,
    setTabIndexClock,
    setUpdatedTabIndexClock,
    setTempTabIndexClock,
    tempTabIndexClock,
}) => {
    setIsDeviceMenu(false);

    // Ensure the device type exists in the mappings

    // if (!deviceState) return;

    const handleDeviceDeletion = (
        tempTabIndex,
        setTempTabIndex,
        setUpdatedTabIndex,
        setTabIndex,
        deviceRefs
    ) => {
        // Find and remove selected device
        const updatedDevices = tempTabIndex[activeTabIndex].filter(device => device.id !== selectedDevice.id);
        const currentDeviceIndex = tempTabIndex[activeTabIndex].findIndex(device => device.id === selectedDevice.id);

        const newTabIndex = { ...tempTabIndex, [activeTabIndex]: updatedDevices };

        setTempTabIndex(newTabIndex);
        setUpdatedTabIndex(newTabIndex);
        setTabIndex(newTabIndex);

        // Reset transform property if ref exists
        if (deviceRefs?.current?.[currentDeviceIndex]) {
            deviceRefs.current[currentDeviceIndex].style.transform = 'translate(0px, 0px)';
        }

        // Remove image related to selected device
        const originalDeviceIndex = tempImages.findIndex(data => data.id === selectedDevice.id);
        if (originalDeviceIndex !== -1) {
            const newUpdatedData = tempImages.filter(data => data.id !== selectedDevice.id);
            setTempImages(newUpdatedData);
            setUpdatedImages(newUpdatedData);
            setIndexesToDeleteImg([...indexesToDeleteImg, originalDeviceIndex]);
        }
    };

    const deviceMappings = {
        Indicator: {
            tempTabIndex: tempTabIndexDevices,
            setTempTabIndex: setTempTabIndexDevices,
            setUpdatedTabIndex: setUpdatedTabIndexDevices,
            setTabIndex: setTabIndexDevices,
            deviceRefs: indicatorRefs
        },
        Display: {
            tempTabIndex: tempTabIndexDisplay,
            setTempTabIndex: setTempTabIndexDisplay,
            setUpdatedTabIndex: setUpdatedTabIndexDisplay,
            setTabIndex: setTabIndexDisplay,
            deviceRefs: displayRefs
        },
        Controller: {
            tempTabIndex: tempTabIndexController,
            setTempTabIndex: setTempTabIndexController,
            setUpdatedTabIndex: setUpdatedTabIndexController,
            setTabIndex: setTabIndexController,
            deviceRefs: controllerRefs
        },
        DigitalIO: {
            tempTabIndex: tempTabIndexIO,
            setTempTabIndex: setTempTabIndexIO,
            setUpdatedTabIndex: setUpdatedTabIndexIO,
            setTabIndex: setTabIndexIO,
            deviceRefs: ioRefs
        },
        FlowMeter: {
            tempTabIndex: tempTabIndexFlowM,
            setTempTabIndex: setTempTabIndexFlowM,
            setUpdatedTabIndex: setUpdatedTabIndexFlowM,
            setTabIndex: setTabIndexFlowM,
            deviceRefs: flowMRefs
        },
        EnergyMeter: {
            tempTabIndex: tempTabIndexEnergyM,
            setTempTabIndex: setTempTabIndexEnergyM,
            setUpdatedTabIndex: setUpdatedTabIndexEnergyM,
            setTabIndex: setTabIndexEnergyM,
            deviceRefs: energyMRefs
        },
        Text: {
            tempTabIndex: tempTabIndexText,
            setTempTabIndex: setTempTabIndexText,
            setUpdatedTabIndex: setUpdatedTabIndexText,
            setTabIndex: setTabIndexText,
            deviceRefs: textRefs
        },
        Motor: {
            tempTabIndex: tempTabIndexMotor,
            setTempTabIndex: setTempTabIndexMotor,
            setUpdatedTabIndex: setUpdatedTabIndexMotor,
            setTabIndex: setTabIndexMotor,
            deviceRefs: motorRefs
        },
        LineChart: {
            tempTabIndex: tempTabIndexLineChart,
            setTempTabIndex: setTempTabIndexLineChart,
            setUpdatedTabIndex: setUpdatedTabIndexLineChart,
            setTabIndex: setTabIndexLineChart,
            deviceRefs: lineChartRefs
        },
        PieChart: {
            tempTabIndex: tempTabIndexPieChart,
            setTempTabIndex: setTempTabIndexPieChart,
            setUpdatedTabIndex: setUpdatedTabIndexPieChart,
            setTabIndex: setTabIndexPieChart,
            deviceRefs: pieChartRefs
        },
        BarChart: {
            tempTabIndex: tempTabIndexBarChart,
            setTempTabIndex: setTempTabIndexBarChart,
            setUpdatedTabIndex: setUpdatedTabIndexBarChart,
            setTabIndex: setTabIndexBarChart,
            deviceRefs: barChartRefs
        },
        Histogram: {
            tempTabIndex: tempTabIndexHistogram,
            setTempTabIndex: setTempTabIndexHistogram,
            setUpdatedTabIndex: setUpdatedTabIndexHistogram,
            setTabIndex: setTabIndexHistogram,
            deviceRefs: histogramRefs
        },
        Gauge: {
            tempTabIndex: tempTabIndexGauge,
            setTempTabIndex: setTempTabIndexGauge,
            setUpdatedTabIndex: setUpdatedTabIndexGauge,
            setTabIndex: setTabIndexGauge,
            deviceRefs: gaugeRefs
        },
        ProgressBar: {
            tempTabIndex: tempTabIndexProgress,
            setTempTabIndex: setTempTabIndexProgress,
            setUpdatedTabIndex: setUpdatedTabIndexProgress,
            setTabIndex: setTabIndexProgress,
            deviceRefs: progressBarRefs
        },
        Grid: {
            tempTabIndex: tempTabIndexGrid,
            setTempTabIndex: setTempTabIndexGrid,
            setUpdatedTabIndex: setUpdatedTabIndexGrid,
            setTabIndex: setTabIndexGrid,
            deviceRefs: gridRefs
        },
        Table: {
            tempTabIndex: tempTabIndexTable,
            setTempTabIndex: setTempTabIndexTable,
            setUpdatedTabIndex: setUpdatedTabIndexTable,
            setTabIndex: setTabIndexTable,
            deviceRefs: tableRefs
        },
        CircularProgress: {
            tempTabIndex: tempTabIndexCircularProgress,
            setTempTabIndex: setTempTabIndexCircularProgress,
            setUpdatedTabIndex: setUpdatedTabIndexCircularProgress,
            setTabIndex: setTabIndexCircularProgress,
            deviceRefs: circularProgressRefs
        },
        Doughnut: {
            tempTabIndex: tempTabIndexDoughnut,
            setTempTabIndex: setTempTabIndexDoughnut,
            setUpdatedTabIndex: setUpdatedTabIndexDoughnut,
            setTabIndex: setTabIndexDoughnut,
            deviceRefs: doughnutRefs
        },
        Line: {
            tempTabIndex: tempTabIndexLines,
            setTempTabIndex: setTempTabIndexLines,
            setUpdatedTabIndex: setUpdatedTabIndexLines,
            setTabIndex: setTabIndexLines,
            deviceRefs: lineRefs
        },
        Square: {
            tempTabIndex: tempTabIndexSquare,
            setTempTabIndex: setTempTabIndexSquare,
            setUpdatedTabIndex: setUpdatedTabIndexSquare,
            setTabIndex: setTabIndexSquare,
            deviceRefs: squareRefs
        },
        Circle: {
            tempTabIndex: tempTabIndexCircle,
            setTempTabIndex: setTempTabIndexCircle,
            setUpdatedTabIndex: setUpdatedTabIndexCircle,
            setTabIndex: setTabIndexCircle,
            deviceRefs: circleRefs
        },
        Polygone: {
            tempTabIndex: tempTabIndexPolygone,
            setTempTabIndex: setTempTabIndexPolygone,
            setUpdatedTabIndex: setUpdatedTabIndexPolygone,
            setTabIndex: setTabIndexPolygone,
            deviceRefs: polygoneRefs
        },
        Pipe: {
            tempTabIndex: tempTabIndexPipe,
            setTempTabIndex: setTempTabIndexPipe,
            setUpdatedTabIndex: setUpdatedTabIndexPipe,
            setTabIndex: setTabIndexPipe,
            deviceRefs: pipeRefs
        },
        Switch: {
            tempTabIndex: tempTabIndexSwitch,
            setTempTabIndex: setTempTabIndexSwitch,
            setUpdatedTabIndex: setUpdatedTabIndexSwitch,
            setTabIndex: setTabIndexSwitch,
            deviceRefs: switchRefs
        },
        Checkbox: {
            tempTabIndex: tempTabIndexCheckbox,
            setTempTabIndex: setTempTabIndexCheckbox,
            setUpdatedTabIndex: setUpdatedTabIndexCheckbox,
            setTabIndex: setTabIndexCheckbox,
            deviceRefs: checkboxRefs
        },
        Radio: {
            tempTabIndex: tempTabIndexRadio,
            setTempTabIndex: setTempTabIndexRadio,
            setUpdatedTabIndex: setUpdatedTabIndexRadio,
            setTabIndex: setTabIndexRadio,
            deviceRefs: radioRefs
        },
        Slider: {
            tempTabIndex: tempTabIndexSlider,
            setTempTabIndex: setTempTabIndexSlider,
            setUpdatedTabIndex: setUpdatedTabIndexSlider,
            setTabIndex: setTabIndexSlider,
            deviceRefs: sliderRefs
        },
        Lamp: {
            tempTabIndex: tempTabIndexLamp,
            setTempTabIndex: setTempTabIndexLamp,
            setUpdatedTabIndex: setUpdatedTabIndexLamp,
            setTabIndex: setTabIndexLamp,
            deviceRefs: lampRefs
        },
        Push: {
            tempTabIndex: tempTabIndexPush,
            setTempTabIndex: setTempTabIndexPush,
            setUpdatedTabIndex: setUpdatedTabIndexPush,
            setTabIndex: setTabIndexPush,
            deviceRefs: pushRefs
        },
        Link: {
            tempTabIndex: tempTabIndexLink,
            setTempTabIndex: setTempTabIndexLink,
            setUpdatedTabIndex: setUpdatedTabIndexLink,
            setTabIndex: setTabIndexLink,
            deviceRefs: LinkRefs
        },
        Clock: {
            tempTabIndex: tempTabIndexClock,
            setTempTabIndex: setTempTabIndexClock,
            setUpdatedTabIndex: setUpdatedTabIndexClock,
            setTabIndex: setTabIndexClock,
            deviceRefs: clockrefs
        },
    };

    if (deviceMappings[currentDevice]) {

        handleDeviceDeletion(deviceMappings[currentDevice].tempTabIndex, deviceMappings[currentDevice].setTempTabIndex, deviceMappings[currentDevice].setUpdatedTabIndex, deviceMappings[currentDevice].setTabIndex, deviceMappings[currentDevice].deviceRefs);
    }

};




export const DeleteNewWidgets = ({
    setIsDeviceMenu,
    currentDevice,
    clickedDeviceIndex,
    setMultipleDevices,
    setMultipleDisplay,
    setMultipleController,
    setMultipleIO,
    setMultipleFlowM,
    setMultipleEnergyM,
    setMultipleMotor,
    setMultipleText,
    setMultipleLineCharts,
    setMultiplePieChart,
    setMultipleBarChart,
    setMultipleHistogram,
    setMultipleGauge,
    setMultipleProgress,
    setMultipleGrid,
    setMultipleTable,
    multipleDevices,
    multipleDisplay,
    multipleController,
    multipleIO,
    multipleFlowM,
    multipleEnergyM,
    multipleMotor,
    multipleText,
    multipleLineCharts,
    multiplePieChart,
    multipleBarChart,
    multipleHistogram,
    multipleGauge,
    multipleProgress,
    multipleGrid,
    multipleTable,
    multipleCircularProgress,
    setMultipleCircularProgress,
    multipleDoughnut,
    setMultipleDoughnut,
    multipleLines,
    setMultipleLines,
    setMultipleCircle,
    multipleCircle,
    setMultipleSquare,
    multipleSquare,
    multiplePolygone,
    setMultiplePolygone,
    multiplePipe,
    setMultiplePipe,
    multipleSwitch,
    setMultipleSwitch,
    multipleCheckbox,
    setMultipleCheckbox,
    multipleRadio,
    setMultipleRadio,
    multipleSlider,
    setMultipleSlider,
    multipleLamp,
    setMultipleLamp,
    multiplePush,
    setMultiplePush,
    multipleLink,
    setMultipleLink,
    multipleClock,
    setMultipleClock,
}) => {
    setIsDeviceMenu(false);

    const handleDeviceDeletion = (devices, setDevices) => {
        const updatedDevices = devices.filter((_, index) => clickedDeviceIndex !== index);
        setDevices(updatedDevices);
    };

    const deviceMappings = {
        Indicator: { devices: multipleDevices, setDevices: setMultipleDevices },
        Display: { devices: multipleDisplay, setDevices: setMultipleDisplay },
        Controller: { devices: multipleController, setDevices: setMultipleController },
        DigitalIO: { devices: multipleIO, setDevices: setMultipleIO },
        FlowMeter: { devices: multipleFlowM, setDevices: setMultipleFlowM },
        EnergyMeter: { devices: multipleEnergyM, setDevices: setMultipleEnergyM },
        Text: { devices: multipleText, setDevices: setMultipleText },
        Motor: { devices: multipleMotor, setDevices: setMultipleMotor },
        LineChart: { devices: multipleLineCharts, setDevices: setMultipleLineCharts },
        PieChart: { devices: multiplePieChart, setDevices: setMultiplePieChart },
        BarChart: { devices: multipleBarChart, setDevices: setMultipleBarChart },
        Histogram: { devices: multipleHistogram, setDevices: setMultipleHistogram },
        Gauge: { devices: multipleGauge, setDevices: setMultipleGauge },
        ProgressBar: { devices: multipleProgress, setDevices: setMultipleProgress },
        Grid: { devices: multipleGrid, setDevices: setMultipleGrid },
        Table: { devices: multipleTable, setDevices: setMultipleTable },
        CircularProgress: { devices: multipleCircularProgress, setDevices: setMultipleCircularProgress },
        Doughnut: { devices: multipleDoughnut, setDevices: setMultipleDoughnut },
        Line: { devices: multipleLines, setDevices: setMultipleLines },
        Square: { devices: multipleSquare, setDevices: setMultipleSquare },
        Circle: { devices: multipleCircle, setDevices: setMultipleCircle },
        Polygone: { devices: multiplePolygone, setDevices: setMultiplePolygone },
        Pipe: { devices: multiplePipe, setDevices: setMultiplePipe },
        Switch: { devices: multipleSwitch, setDevices: setMultipleSwitch },
        Checkbox: { devices: multipleCheckbox, setDevices: setMultipleCheckbox },
        Radio: { devices: multipleRadio, setDevices: setMultipleRadio },
        Slider: { devices: multipleSlider, setDevices: setMultipleSlider },
        Lamp: { devices: multipleLamp, setDevices: setMultipleLamp },
        Push: { devices: multiplePush, setDevices: setMultiplePush },
        Link: { devices: multipleLink, setDevices: setMultipleLink },
        Clock: { devices: multipleClock, setDevices: setMultipleClock },
    };

    if (deviceMappings[currentDevice]) {
        handleDeviceDeletion(deviceMappings[currentDevice].devices, deviceMappings[currentDevice].setDevices);
    }
};



